// extracted by mini-css-extract-plugin
export default {"container":"container---p3XeT","handle":"handle---ai9ct","content":"content---S_nVj","defaultDraggableBox":"defaultDraggableBox---k2XMb","pickedUp":"pickedUp---iXaiF"};